import { promiseImpl } from 'ejs';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import { Intent, Classes,Popover,Menu,MenuDivider,MenuItem } from "@blueprintjs/core";
import { Button,Radio,RadioGroup, Card, Elevation,Slider, Overlay,H4,Icon } from "@blueprintjs/core";
import {Toaster, Position} from "@blueprintjs/core";
import  {MSG_VISIO} from "../MessagesVisio.js"
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});

/*const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};*/
export default class CardFonctions extends React.Component  <{}> {
  msg_visio=MSG_VISIO;
  state = {
    conference:{selected:false,objtabid:[],groupes:[],ID:-1},
    recordaudio:{selected:false,objtabid:[],groupes:[],ID:-1},
    mosaique:{selected:false,objtabid:[],groupes:[],ID:-1},
    ipslocal:false,
    force_width:680,
    tabips:[],
    select_matiere_id:"-1",
    choix_matiere:false,
    frameurl:undefined,
    selected_classe_item:{},
    datamatieres:this.props.datamatieres
  }  
  
  constructor(props) {
        super(props);
      }
  componentDidMount () {     
    //JSON.stringify(testObject)
    var st=localStorage.getItem("conference");
    if((st!="") && (st!=null))
    {
      st=JSON.parse(st);
      this.setState({conference:st});
    }
    else
    {
      var st2={selected:false,groupes:[]}
      this.setState({conference:st2});
    }
    st=localStorage.getItem("recordaudio");
    if((st!="") && (st!=null))
    {
      st=JSON.parse(st);
      this.setState({recordaudio:st});
    }
    else
    {
      var st2={selected:false,groupes:[]}
      this.setState({recordaudio:st2});
    }
    
    
    st=localStorage.getItem("select_matiere_id");
    if(st!="")this.setState({select_matiere_id:st}); 
    console.log(this.props.selected_classe_item)
    this.setState({datamatieres:this.props.datamatieres})
  }
 
  componentDidUpdate(prevProps, prevState) {
    if(this.props.frameurl!=this.state.frameurl)this.setState({frameurl:this.props.frameurl});
    if(this.props.datamatieres!=this.state.datamatieres)this.setState({datamatieres:this.props.datamatieres});
    if(this.props.conference!=this.state.conference)this.setState({conference:this.props.conference});
    if(this.props.recordaudio!=this.state.recordaudio)this.setState({recordaudio:this.props.recordaudio});
    if(this.props.mosaique!=this.state.mosaique)this.setState({mosaique:this.props.mosaique});
    if(this.props.selected_classe_item!=this.state.selected_classe_item)
    {
      this.setState({selected_classe_item:this.props.selected_classe_item});
      var obj=[];
      this.props.selected_classe_item[0].students.map((it)=>{
        if (it.iplocal!="")obj.push(it);
      });
      this.setState({tabips:obj});
      this.setState({ipslocal:obj.length>0});

    }
    
    localStorage.setItem("conference",JSON.stringify(this.state.conference));
    localStorage.setItem("recordaudio",JSON.stringify(this.state.recordaudio));
  }
  
 
  handletaille=()=>{
    this.setState({force_width:"100%"});
    this.setState({showcontenu:"block"});
    this.setState({elargir:"arrow-left"});
  }
  handleSelectMatiere =(ev)=>{
    //console.log(ev);
    this.setState({select_matiere_id:ev.currentTarget.value});
    localStorage.setItem("select_matiere_id",ev.currentTarget.value);
    this.props.ForcerMatiere(this.props.selected_classe_id,ev.currentTarget.value);
  }
  handleMosaique=(classeid,groupe_nom)=>{
   
    var obj=[];
    var etat=this.isActif(this.state.mosaique,groupe_nom);
    etat=!etat;
    if(etat)
    {
     this.state.mosaique.groupes.map((it)=>obj.push(it));
      obj.push(groupe_nom);
    }
    else
    {
     this.state.mosaique.groupes.map((it)=>{ if (it!=groupe_nom)obj.push(it);});
    }
    var objmosaique=this.state.mosaique;
    objmosaique.groupes=obj;
    //var st={selected:etat2,groupes:obj}
    //this.setState({recordaudio:st});
    this.props.MettreEnMosaique(classeid,etat,groupe_nom,objmosaique);
   
   }
  handleMettreEnEnregistrement=(classeid,groupe_nom)=>{
   
    var obj=[];
    var etat=this.isActif(this.state.recordaudio,groupe_nom);
    etat=!etat;
    if(etat)
    {
     this.state.recordaudio.groupes.map((it)=>obj.push(it));
      obj.push(groupe_nom);
    }
    else
    {
     this.state.recordaudio.groupes.map((it)=>{ if (it!=groupe_nom)obj.push(it);});
    }
    //var etat2=obj.length>0;
    var objrecordaudio=this.state.recordaudio;
    objrecordaudio.groupes=obj;
    //var st={selected:etat2,groupes:obj}
    //this.setState({recordaudio:st});
    this.props.MettreEnEnregistrement(classeid,etat,groupe_nom,objrecordaudio);
   }
  handleMettreEnConference=(classeid,groupe_nom)=>{
   
   var obj=[];
   var etat=this.isActif(this.state.conference,groupe_nom);
   etat=!etat;
   if(etat)
   {
    this.state.conference.groupes.map((it)=>obj.push(it));
     obj.push(groupe_nom);
   }
   else
   {
    this.state.conference.groupes.map((it)=>{ if (it!=groupe_nom)obj.push(it);});
   }
   //var etat2=obj.length>0;
   var objconference=this.state.conference;
   objconference.groupes=obj;
   //var st={selected:etat2,groupes:obj}
   this.props.MettreEnConference(classeid,etat,groupe_nom,objconference);
   //this.setState({conference:objconf});
  }
  
  isActifRGB=(obj_fonction,groupe_nom)=>{
    var ret="rgba(255,255,255,1)";
    if(obj_fonction==undefined) return ret;
    obj_fonction.groupes.map((it)=>
    {
      if(it==groupe_nom) ret="rgba(88,201,255,0.5)";
    });
    return ret;
  }
  isActif=(obj_fonction,groupe_nom)=>{
    var ret=false;
    if(obj_fonction==undefined) return ret;
    obj_fonction.groupes.map((it)=>
    {
      if(it==groupe_nom) ret=true;
    });
    return ret;
  }
  showRedirige = (url) => {
    if(url!=undefined)
    {
      console.log("url:"+url)
      //window.location=url;
      const varstyle="style='width:100%;height:800px;display:block;position: relative;border: 0;z-index:1'";
      return <div style={{width:'100%',height:'100%',display:'block',marginTop:5, position: 'relative',border: '0'}}  dangerouslySetInnerHTML={{ __html: "<iframe id='iframe_visio'" +varstyle+"  src='"+url+"' />"}} />;
    }
  
  }
   render() {
    
    

    return(
     <div>
     <Card style={{width:this.state.force_width,marginLeft:4,marginTop:0, objectFit:'contain'}} interactive={false} elevation={Elevation.TWO}>
     <div>
       <H4>Fonctions de groupes</H4>
       {this.state.select_matiere_id<0?<div style={{marginBottom:10}}><Icon style={{marginRight:5}} icon="info-sign"></Icon> Sélectionner une matière pour activer les fonctions de groupes</div>:<div style={{marginBottom:10}}><Icon icon="info-sign" style={{marginRight:5}}></Icon>Les étudiants travaillent dans la matière {this.state.datamatieres.filter((it)=>it.ID==this.state.select_matiere_id).map((itemmat)=>itemmat.matiere)} </div>}
        <Popover content={<Menu>
          <MenuItem icon="cross" text="Fermer" />
          <MenuDivider />
          <MenuItem disabled={this.state.select_matiere_id<0} icon="layers"  style={{backgroundColor:this.isActifRGB(this.state.conference,"all")}} onClick={(ev)=>{ev.preventDefault();this.handleMettreEnConference(this.props.selected_classe_id,"all");}} text="Tous les groupes" />
          <MenuDivider />
          {this.props.selected_classe_item[0].groupe.map((itemg)=>{
          return(<MenuItem disabled={this.state.select_matiere_id<0} shouldDismissPopover={false}  style={{backgroundColor:this.isActifRGB(this.state.conference,itemg.nom)}} icon="layer" onClick={(ev)=>{ev.preventDefault();this.handleMettreEnConference(this.props.selected_classe_id,itemg.nom);}} text={itemg.nom} />)
          })}
          </Menu>} position={Position.RIGHT_TOP}>
          <Button disabled={this.state.select_matiere_id<0} intent={this.state.conference.selected?Intent.DANGER:Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 20px',padding: '1px 20px 1px 5px'}} icon="headset"
        >Mettre en conférence</Button>
       </Popover>
       <Popover content={<Menu>
          <MenuItem icon="cross" text="Fermer" />
          <MenuDivider />
          <MenuItem disabled={this.state.select_matiere_id<0} icon="layers"  style={{backgroundColor:this.isActifRGB(this.state.recordaudio,"all")}} onClick={(ev)=>{ev.preventDefault();this.handleMettreEnEnregistrement(this.props.selected_classe_id,"all");}} text="Tous les groupes" />
          <MenuDivider />
          {this.props.selected_classe_item[0].groupe.map((itemg)=>{
          return(<MenuItem disabled={this.state.select_matiere_id<0} shouldDismissPopover={false}  style={{backgroundColor:this.isActifRGB(this.state.recordaudio,itemg.nom)}} icon="layer" onClick={(ev)=>{ev.preventDefault();this.handleMettreEnEnregistrement(this.props.selected_classe_id,itemg.nom);}} text={itemg.nom} />)
          })}
          </Menu>} position={Position.RIGHT_TOP}>
       <Button disabled={this.state.select_matiere_id<0} intent={this.state.recordaudio.selected?Intent.DANGER:Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 20px',padding: '1px 20px 1px 5px'}} icon="record"
        >Enregistrement audio</Button>
        </Popover>
        <Popover content={<Menu>
          <MenuItem icon="cross" text="Fermer" />
          <MenuDivider />
          <MenuItem icon="layers"  style={{backgroundColor:this.isActifRGB(this.state.mosaique,"all")}} onClick={(ev)=>{ev.preventDefault();this.handleMosaique(this.props.selected_classe_id,"all");}} text="Tous les groupes" />
          <MenuDivider />
          {this.props.selected_classe_item[0].groupe.map((itemg)=>{
          return(<MenuItem  shouldDismissPopover={false}  style={{backgroundColor:this.isActifRGB(this.state.mosaique,itemg.nom)}} icon="layer" onClick={(ev)=>{ev.preventDefault();this.handleMosaique(this.props.selected_classe_id,itemg.nom);}} text={itemg.nom} />)
          })}
          </Menu>} position={Position.RIGHT_TOP}>
       <Button disabled={!this.state.ipslocal} intent={this.state.mosaique.selected?Intent.DANGER:Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 20px',padding: '1px 20px 1px 5px'}} icon="desktop"
        >Mosaïque</Button>
        </Popover>
        
     </div>
     {this.showRedirige(this.state.frameurl)}
     </Card>
     <Overlay isOpen={this.state.choix_matiere} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '80px 25%'}}>
                        <H4>Choisir une matière pour tous les groupes</H4>
                        
                        <ul style={{marginLeft: -40}}>Le choix d'une matière vous permettra de forcer les étudiants de la classe:
                        <li style={{marginLeft: 40}}>A rejoindre votre classe</li>
                        <li style={{marginLeft: 40}}>Pour les étudiants, de travailler seulement avec la matière que vous allez choisir</li>
                        </ul>
                        <p></p>
                        <RadioGroup
                            label="Choix de la matière de travail"
                            onChange={this.handleSelectMatiere}
                            selectedValue={this.state.select_matiere_id}
                        >
                           <Radio label="Aucune" value="-1" />
                           {this.state.datamatieres.map((itemmat)=><Radio label={itemmat.matiere} value={itemmat.ID.toString()} />)}
                        </RadioGroup>
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({choix_matiere:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                            
                        </div>
                    </div>
        </Overlay>
     </div>
     
     );
}
}

